import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import {
  BorderStyling,
  CmsUrl,
  PrimaryFooterColumn,
  PrimaryFooterLink,
} from '@digital-platform/rs-cms/domain';
import { BasePTypeComponent } from '../base-ptype/base-ptype.component';
import { DynamicContentWrapperComponent } from '../dynamic-content-wrapper/dynamic-content-wrapper.component';

@Component({
  selector: 'digital-platform-primary-footer-column',
  standalone: true,
  imports: [CommonModule, DynamicContentWrapperComponent],
  templateUrl: './primary-footer-column.component.html',
  styleUrls: ['./primary-footer-column.component.scss'],
})
export class PrimaryFooterColumnComponent
  extends BasePTypeComponent
  implements PrimaryFooterColumn
{
  public override type = 'primaryFooterColumn' as const;

  @Input() border!: BorderStyling;
  @Input() nestedContent: PrimaryFooterLink[] = [];
  @Input() url: CmsUrl = [];
  @Input() open = false;
}
